import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
// import { Modal } from "bootstrap";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

class ListVisitScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      hasMore: false,
      page: 1,
      totalPage: 0,
      modalVisible: false,
      modalData: {},
    };
  }
  componentDidMount() {
    this.fetchData(1);
  }

  fetchData = async (activePage) => {
    const dt = await API(
      this,
      "get",
      URL_PATH.listEnquiries(activePage, this.state.perPageItem)
    );
    const { data, page, totalPage, perPageItem, hasMore } = dt;
    this.setState({
      users: data,
      totalPage,
      hasMore,
      page: parseInt(page),
      page,
      perPageItem,
    });
  };
  pageNumbers = (page, totalPages) => {
    let pageNumbers = [];
    const startIndex = page > 10 ? page - 10 : 1;
    const endIndex = page + 10 < totalPages ? page + 10 : totalPages;
    for (let i = startIndex; i <= endIndex; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers.map((number) => (
      <li
        className="page-item"
        onClick={() => {
          this.fetchData(number);
        }}
      >
        <a
          className="page-link"
          style={{
            backgroundColor: page == number ? "#121212" : "white",
            color: page == number ? "white" : "black",
          }}
          href="#"
        >
          {number}
        </a>
      </li>
    ));
  };

  hideModal = () => {
    this.setState({ modalVisible: false });
  };

  Modal = () => {
    // return <h1>hello</h1>;
    const {
      modalData: {
        id = null,
        suffix = null,
        first_name = null,
        last_name = null,
        email = null,
        phone = null,
        organization = null,
        help = null,
        interest = null,
        message = null,
        created_at = null,
      },
    } = this.state;
    return (
      <Modal show={this.state.modalVisible} onHide={this.hideModal} size="xs">
        <Modal.Header>
          <Modal.Title>Enquiry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="first_name">First Name</label>
                <h5>{first_name}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="last_name">Last Name</label>
                <h5>{last_name}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <h5>{email}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <h5>{phone}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="organization">Organization</label>
                <h5>{organization}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="help">Help</label>
                <h5>{help}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="interest">Interest</label>
                <h5>{interest}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <h5>{message}</h5>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="created_at">Created At</label>
                <h5>{created_at}</h5>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.send} appearance="primary">
            Mark as read
          </Button>
          <Button onClick={this.hideModal} appearance="subtle">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  showDetails = async (id) => {
    const dt = await API(this, "get", URL_PATH.showEnquiry(id));
    console.log(dt);
    this.setState({ modalData: dt, modalVisible: true });
  };
  render() {
    const { users, page, totalPage, perPageItem, modalVisible } = this.state;
    // setTimeout(() => window.alert("hello from render"), 1500);
    return (
      <div className="container">
        {modalVisible && <this.Modal />}
        <h1>Enquiries</h1>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Email</th>
              <th>role</th>
              <th>Created At</th>
              {/* <th>Updated At</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>
                  {item.suffix}
                  {item.first_name}
                  {item.last_name}
                </td>
                <td>{item.email}</td>
                <td>{item.phone}</td>

                <td>{item.created_at.split("T")[0]}</td>
                {/* <td>{item.updated_at}</td> */}
                <td>
                  <a
                    onClick={() => this.showDetails(item.id)}
                    className="btn btn-primary m-1"
                  >
                    View
                  </a>
                  {/*
                                    <Link
                                        to={routes.admin.franchise.update(
                                            item.id
                                        )}
                                        className="btn btn-primary m-1"
                                    >
                                        Edit
                                    </Link> */}
                  {/* <Link
                                        // to={routes.admin.gallery.delete(
                                        //     item.id
                                        // )}
                                        className="btn btn-danger m-1"
                                    >
                                        Delete
                                    </Link> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* pages */}

        <nav aria-label="Page navigation">
          <ul className="pagination container justify-content-center">
            <li className="page-item">
              <a className="page-link" href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span className="sr-only">Previous</span>
              </a>
            </li>
            {this.pageNumbers(page, totalPage)}
            <li className="page-item">
              <a className="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span className="sr-only">Next</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default redux(ListVisitScreen);
